/** TODO: Delete when migrating apply */
import React from 'react';
import Header from 'common-mui/components/Header';
import { Box } from '@mui/material';

const container = {
  height: '100%',
  padding: '15px 0',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  margin: '0 20px',
};

const outer = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flex: 1,
};

const inner = {
  maxWidth: '500px',
  width: '100%',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
};

const Layout = ({ children }) => (
  <Box sx={container}>
    <Header />
    <Box sx={outer}>
      <Box sx={inner}>
        { children }
      </Box>
    </Box>
  </Box>
);

export default Layout;
